/**
 * Base API client untuk melakukan request ke backend API
 */

// URL API berdasarkan environment
// Base URL harus mengarah ke Cloudflare Worker Anda
const API_BASE_URL = 'https://jamaah-worker.lilotrik86.workers.dev';

/**
 * Method untuk melakukan request API dengan fetch API
 * 
 * @param {string} endpoint - Endpoint API yang akan diakses (tanpa base URL)
 * @param {Object} options - Options untuk fetch API
 * @returns {Promise<any>} - Response dari API dalam format JSON
 */
async function apiRequest(endpoint, options = {}) {
  // Default headers
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    // Tangani berbagai kemungkinan respons
    if (!response.ok) {
      // Coba parse response JSON jika ada
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        // Jika bukan JSON, gunakan text response
        const errorText = await response.text();
        throw new Error(
          `Request failed with status ${response.status}: ${errorText || 'No error details available'}`
        );
      }
      throw new Error(
        errorData.message || 
        `Request failed with status ${response.status}`
      );
    }

    // Cek apakah respons bisa diparse sebagai JSON
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    } else {
      // Jika bukan JSON, kembalikan response text
      const textResponse = await response.text();
      console.warn('Response is not JSON:', textResponse);
      return { data: textResponse, isTextResponse: true };
    }
  } catch (error) {
    console.error('API request error:', error);
    throw new Error(`Failed to fetch: ${error.message}`);
  }
}

/**
 * HTTP method wrappers
 */
export const apiClient = {
  /**
   * GET request
   * 
   * @param {string} endpoint - API endpoint
   * @param {Object} options - Fetch options
   */
  get: (endpoint, options = {}) => 
    apiRequest(endpoint, { ...options, method: 'GET' }),

  /**
   * POST request
   * 
   * @param {string} endpoint - API endpoint
   * @param {Object} body - Request body
   * @param {Object} options - Fetch options
   */
  post: (endpoint, body, options = {}) => 
    apiRequest(endpoint, { 
      ...options, 
      method: 'POST',
      body: JSON.stringify(body)
    }),

  /**
   * PUT request
   * 
   * @param {string} endpoint - API endpoint
   * @param {Object} body - Request body
   * @param {Object} options - Fetch options
   */
  put: (endpoint, body, options = {}) => 
    apiRequest(endpoint, { 
      ...options, 
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  /**
   * DELETE request
   * 
   * @param {string} endpoint - API endpoint
   * @param {Object} options - Fetch options
   */
  delete: (endpoint, options = {}) => 
    apiRequest(endpoint, { ...options, method: 'DELETE' })
};

export default apiClient;